module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image3_08d6ef8761219b99640b1cb0f7339d0d.png";